import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import EditOffOutlinedIcon from '@mui/icons-material/EditOffOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, TextField, Typography, IconButton, InputLabel } from '@mui/material';

import { Flex } from '../../components';

export const EditTextControls = ({ text, label, onSave, hideEdit = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);

  const handleClose = () => {
    setValue(text);
    setIsEditing(false);
  };

  const handleSave = () => {
    onSave?.(value);
    setIsEditing(false);
  };

  return (
    <Flex.H sx={{ alignItems: 'center', gap: '20px' }}>
      {isEditing ? (
        <>
          {label && (
            <Box>
              <InputLabel>{label}</InputLabel>
            </Box>
          )}

          <TextField
            variant="standard"
            defaultValue={value}
            multiline
            onChange={(evt) => setValue(evt.target.value)}
          />

          <IconButton
            aria-controls="Edit rule"
            aria-haspopup="true"
            size="large"
            sx={{ padding: '8px' }}
            onClick={handleClose}
          >
            <EditOffOutlinedIcon fontSize="large" sx={{ color: '#181d1f' }} />
          </IconButton>

          <IconButton
            aria-controls="Edit rule"
            aria-haspopup="true"
            size="large"
            sx={{ padding: '8px' }}
            onClick={handleSave}
          >
            <DoneAllOutlinedIcon fontSize="large" sx={{ color: '#181d1f' }} />
          </IconButton>
        </>
      ) : (
        <>
          {label && (
            <Box>
              <InputLabel>{label}</InputLabel>
            </Box>
          )}
          <Typography sx={{ width: '100%', color: '#181d1f', fontSize: '14px' }}>
            {text}
          </Typography>
          {hideEdit ? null : (
            <IconButton
              aria-controls="Edit rule"
              aria-haspopup="true"
              size="large"
              sx={{ padding: '8px' }}
              onClick={() => setIsEditing(true)}
            >
              <EditOutlinedIcon fontSize="large" sx={{ color: '#181d1f' }} />
            </IconButton>
          )}
        </>
      )}
    </Flex.H>
  );
};

EditTextControls.propTypes = {
  text: PropTypes.string,
  label: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  hideEdit: PropTypes.bool,
};
